import { FIELD_NAMES } from '../../constants';
import { SCHEDULING_PREF_PATHS } from '../../constants/schedulingPreferencesConstants';
import { isSubtaskSchedulingPreference } from '../health-care-settings/schedulingPreferencesUtils';

export const EDIT_STRATEGIES = {
  SUBTASK_NAVIGATE: 'SUBTASK_NAVIGATE',
  CANNOT_EDIT: 'CANNOT_EDIT',
  OPEN_EDIT_MODAL: 'OPEN_EDIT_MODAL',
  OPEN_REMOVE_MODAL: 'OPEN_REMOVE_MODAL',
  NO_OP: 'NO_OP',
};

const SUBTASK_PATHS = {
  [FIELD_NAMES.SCHEDULING_PREF_CONTACT_METHOD]:
    SCHEDULING_PREF_PATHS.CONTACT_METHOD,
  [FIELD_NAMES.SCHEDULING_PREF_CONTACT_TIMES]:
    SCHEDULING_PREF_PATHS.CONTACT_TIMES,
  [FIELD_NAMES.SCHEDULING_PREF_APPOINTMENT_TIMES]:
    SCHEDULING_PREF_PATHS.APPOINTMENT_TIMES,
};

export const getSubtaskPath = fieldName => SUBTASK_PATHS[fieldName];

/**
 * What clicking "Edit" should do: leave the page for a subtask route, refuse
 * because another field holds unsaved edits, or open the inline edit modal.
 *
 * `canNavigate` is whether a router is available — the class only received a
 * `history` prop through its withRouter-wrapped export, and fields rendered
 * outside a router fell through to inline editing.
 */
export const getEditStrategy = ({
  fieldName,
  blockEditMode,
  canNavigate = false,
}) => {
  if (isSubtaskSchedulingPreference(fieldName) && canNavigate) {
    const path = getSubtaskPath(fieldName);

    // Mirrors the class's `default: return` — a subtask field with no route
    // did nothing at all rather than falling back to inline editing.
    return path
      ? { type: EDIT_STRATEGIES.SUBTASK_NAVIGATE, path }
      : { type: EDIT_STRATEGIES.NO_OP };
  }

  if (blockEditMode) {
    return { type: EDIT_STRATEGIES.CANNOT_EDIT };
  }

  // Errors are cleared on open so an alert from a previous transaction doesn't
  // greet the user inside a fresh edit view.
  return {
    type: EDIT_STRATEGIES.OPEN_EDIT_MODAL,
    modal: fieldName,
    clearErrors: true,
  };
};

export const getRemoveStrategy = ({ fieldName, blockEditMode }) => {
  if (blockEditMode) {
    return { type: EDIT_STRATEGIES.CANNOT_EDIT };
  }

  return {
    type: EDIT_STRATEGIES.OPEN_REMOVE_MODAL,
    modal: `remove-${fieldName}`,
    clearErrors: true,
  };
};
